<template>
  <div>
    <v-container fluid class="px-0">
      <v-row>
        <v-col cols="6" sm="6" md="6" lg="3" xl="2">
          <div class="mb-2">
            <v-btn
              outlined
              elevation="1"
              block
              color="info"
              @click="handleSlug('lotto_thai')"
            >
              หวยรัฐ
            </v-btn>
          </div>
        </v-col>
        <v-col cols="6" sm="6" md="6" lg="3" xl="2">
          <div class="mb-2">
            <v-btn
              outlined
              elevation="1"
              block
              color="yellow darken-2"
              @click="handleSlug('soidown')"
            >
              สอยดาวและยี่กี
            </v-btn>
          </div>
        </v-col>
        <v-col cols="6" sm="6" md="6" lg="3" xl="2">
          <div class="mb-2">
            <v-btn
              outlined
              elevation="1"
              block
              color="success"
              @click="handleSlug('stock')"
            >
              หวยหุ้น
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :footer-props="footer"
            :headers="headers"
            :items.sync="items"
            :loading="loading"
            :multi-sort="false"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-0"
            dense
            item-key="id"
          >
            <!-- item -->
            <template #item.detail="{ item }">
              <div class="text-center">
                <v-btn
                  outlined
                  small
                  color="green darken-3"
                  title="ดูรายละเอียด"
                  @click="displayDialog(item)"
                >
                  ดูโพย
                </v-btn>
                <v-btn
                  v-if="
                    item.game.status === 'open' &&
                    (item.status == 'created' || item.status == 'pending') &&
                    role == 'user'
                  "
                  outlined
                  small
                  class="ma-1"
                  color="red darken-2"
                  title="ยกเลิกโพย"
                  @click="cancelTicket(item.id)"
                >
                  ยกเลิก
                </v-btn>
              </div>
            </template>
            <template #item.game_name="{ item }">
              <a :href="'/lotto/' + item.game.id" target="blank">
                <span class="text-danger"
                  >{{ item.game.master.name }} {{ item.game.readable_edition
                  }}{{ item.game.game_thai_date }}</span
                >
              </a>
            </template>
            <template #item.created_at="{ item }">
              <span v-if="item.created_at" class="d-block">{{
                $moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")
              }}</span>
            </template>

            <template #item.amount="{ item }">
              <span>{{
                Intl.NumberFormat("th-TH", {
                  style: "currency",
                  currency: "THB",
                }).format(item.amount)
              }}</span>
            </template>

            <template #item.win_amount="{ item }">
              <span>{{
                Intl.NumberFormat("th-TH", {
                  style: "currency",
                  currency: "THB",
                }).format(item.win_amount > 0 ? item.win_amount : 0)
              }}</span>
            </template>

            <template #item.status="{ item }">
              <v-chip
                v-if="item.status === 'pending'"
                class="ma-2 text-lg"
                label
                small
                color="warning"
              >
                กำลังประมวลผล
              </v-chip>
              <v-chip
                v-else-if="item.status === 'created'"
                class="ma-2 text-lg"
                label
                small
                color="light-blue"
                text-color="white"
              >
                รอยืนยันผล
              </v-chip>
              <v-chip
                v-else-if="item.status === 'cancel_by_game'"
                class="ma-2 text-lg text-white"
                label
                small
                color="red"
              >
                ยกเลิกเกมส์
              </v-chip>
              <v-chip
                v-else-if="item.status === 'cancel_by_user'"
                class="ma-2 text-lg text-white"
                label
                small
                color="red"
              >
                ยกเลิกโพย
              </v-chip>
              <v-chip
                v-else-if="item.status === 'committed'"
                class="ma-2 text-lg"
                label
                small
                color="warning"
              >
                กำลังคำนวน
              </v-chip>
              <v-chip
                v-else-if="item.status === 'complete'"
                class="ma-2 text-lg text-white"
                label
                small
                color="success"
              >
                จบเกมส์
              </v-chip>
            </template>

            <template #item.id="{ item }">
              <span>{{ `#${item.lotto_game_id}${item.id}` }}</span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-if="selectedItem" v-model="selectedItem" fullscreen scrollable>
      <v-card>
        <v-toolbar color="red" height="55">
          <v-card-title class="pa-0">
            <span class="text-body-1 text-uppercase text-light">{{
              gameName
            }}</span>
          </v-card-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pt-3 pb-3 px-3">
          <ticket-number :transaction="ticketNumberItem" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="preload"
      v-model="preload"
      persistent
      width="500"
      max-width="100vw"
    >
      <v-card class="pa-md-10 mx-lg-auto">
        <v-container class="text-center">
          <v-progress-circular
            :size="100"
            :width="10"
            indeterminate
            color="red"
          />
        </v-container>
      </v-card>
    </v-dialog>
    <b-modal id="bv-modal-result" size="xl" hide-footer />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone";
import ticketNumber from "./ticket-number-table.vue";

export default {
  name: "TicketTable",
  components: {
    ticketNumber,
  },
  props: {
    role: {
      type: String,
      default: "",
    },
    userId: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      footer: {
        itemsPerPageOptions: [10, 25, 50, 100],
      },
      loading: true,
      search: false,
      sortable: false,
      headers: [
        {
          text: "ดูโพย",
          value: "detail",
          align: "center",
          justify: "center",
          sortable: false,
        },
        {
          text: "เกมส์",
          value: "game_name",
          align: "center",
          justify: "center",
          sortable: false,
        },
        {
          text: "เวลาแทง",
          value: "created_at",
          align: "center",
          justify: "center",
          sortable: false,
        },
        {
          text: "ยอดแทง",
          value: "amount",
          align: "center",
          cellClass: "text-monospace",
          sortable: false,
        },
        {
          text: "ยอดถูก",
          value: "win_amount",
          align: "center",
          justify: "center",
          cellClass: "text-monospace",
          sortable: false,
        },
        {
          text: "สถานะ",
          value: "status",
          align: "center",
          sortable: false,
        },
        {
          text: "โพย",
          value: "id",
          align: "center",
          sortable: false,
        },
      ],
      items: [],
      totalItems: 0,
      options: {},
      query: {
        slug: "all",
        dateRange: [
          moment().add(-1, "months").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ],
      },
      showDateDialog: false,
      selectedItem: false,
      gameName: "",
      ticketNumberItem: [],
      preload: false,
    };
  },
  computed: {
    dateRangeText() {
      return this.query.dateRange.join(" ~ ");
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },

  mounted() {},

  methods: {
    handleSlug(slugvalue) {
      this.query.slug = slugvalue;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      axios
        .get(`/api/user/ticket/${this.userId}`, {
          params: {
            page: this.options.page,
            sortBy: this.options.sortBy[0],
            sortDirection:
              this.options.sortDesc.length > 0
                ? this.options.sortDesc[0]
                  ? "ASC"
                  : "DESC"
                : null,
            pageSize: this.options.itemsPerPage,
            start: this.query.dateRange[0],
            end: this.query.dateRange[this.query.dateRange.length - 1],
            slug: this.query.slug,
          },
        })
        .then((response) => {
          this.items = response.data.data;
          this.totalItems = response.data.total;
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.loading = false;
        });
    },

    displayDialog(item) {
      this.gameName = `#${item.lotto_game_id}${item.id} ${item.game.master.name} ${item.game.readable_edition}`;
      this.preload = true;
      axios
        .get(`/api/user/ticketNumber/${item.id}`)
        .then((response) => {
          Vue.set(this, "ticketNumberItem", response.data);
        })
        .finally(() => {
          this.preload = false;
          this.selectedItem = true;
        });
    },
    cancelTicket(ticketId) {
      if (confirm("ต้องการยกเลิกโพย")) {
        axios
          .delete(`/api/lotto/bet/${ticketId}`)
          .then((response) => {
            if (response.status == 200) {
              Vue.$toast.open({
                message: "ยกเลิกโพยสำเร็จ",
                type: "success",
                duration: 5000,
                position: "top-right",
              });
            }
          })
          .finally(() => {
            this.fetchData();
          })
          .catch((error) => {
            if (error.response.status == 410) {
              Vue.$toast.open({
                message: "เกมส์จบแล้ว",
                type: "error",
                duration: 5000,
                position: "top-right",
              });
            } else {
              Vue.$toast.open({
                message: "กรุณาลองใหม่",
                type: "error",
                duration: 5000,
                position: "top-right",
              });
            }
          });
      }
    },

    closeDialog() {
      this.selectedItem = false;
    },
  },
};
</script>
